export const solutions = [
  {
    slug: 'it-ai',
    title: 'IT Solutions including AI Platforms',
    description:
      'We have the experience, through our own resources and through our partners, to plan and implement IT solutions including AI solution platforms across many vertical markets.',
    icon: 'Server',
    items: [
      'Government sector, including schools, hospitals, social security, transportation, taxation, finance and treasury, public security, safety, defense, and customs',
      'Oil and gas: ERP systems and process automation',
      'Research, consultation, and feasibility studies in both macro and micro economics',
      'Other solutions can be customised for any other business sector',
    ],
  },
  {
    slug: 'telecom',
    title: 'Telecom',
    description:
      'The company has experience and partnerships to plan and implement telecommunications infrastructure and network solutions.',
    icon: 'RadioTower',
    items: [
      'Point-to-point and point-to-multi-point microwave systems',
      'Fiber optic transmission and access solutions',
      'All-IP core networks',
      'WiMax access networks',
      'WiFi hotspots and WiFi meshed access networks',
      'IT solutions for telecoms',
      'Supply of different types of rechargeable batteries and accessories',
    ],
  },
  {
    slug: 'military',
    title: 'Military',
    description:
      'Specialised equipment, materials, and logistics support for defence and security environments.',
    icon: 'Shield',
    items: [
      'Shooting ranges, simulation rooms, equipment, and security solutions',
      'Supply of armoured steel, glass, suspensions, hinges, coils, and related accessories',
      'Equipment and logistics services for military bases',
    ],
  },
  {
    slug: 'manpower',
    title: 'Manpower',
    description:
      'We have the ability to secure manpower for different sectors.',
    icon: 'Users',
    items: [
      'Engineers',
      'Technicians',
      'Welders',
      'Steel fabricators',
      'Skilled labourers',
    ],
  },
];
